import addDays from 'date-fns/addDays';
import isWithinInterval from 'date-fns/isWithinInterval';
import subDays from 'date-fns/subDays';
import localForage from 'localforage';
import orderBy from 'lodash/orderBy';
import { EventData } from '../../types';

export const PRINT_KEY = 'arrival-printer-id';
export const EVENT_KEY = 'arrival-event-id';

/**
 * The fixed Arrival bars sit above the page and the App Bar (MUI appBar 1100)
 * but below MUI drawers, menus and dialogs (1200+), so the App Bar's bottom
 * sheets, the nav drawer and the session dialog are never covered on phones.
 * The bars' own panels and dialogs use 1000001+ and stay on top.
 */
export const ARRIVAL_BAR_Z_INDEX = 1150;

export async function storeItemId(params: { key: string; ItemId: number }) {
  await localForage.setItem(params.key, params.ItemId.toString());
}

export async function checkForItemId(params: { key: string }) {
  const ItemId = await localForage.getItem(params.key);

  if (ItemId && typeof ItemId === 'string') {
    return ItemId;
  } else {
    return null;
  }
}

export function eventsReadyForCheckIn(params: { data: EventData[] }) {
  const newEvents = params.data.filter((i) => {
    if (i.DateBegin && i.DateEnd) {
      const DateBegin = subDays(new Date(i.DateBegin), 3);
      const DateEnd = addDays(new Date(i.DateEnd), 2);
      return isWithinInterval(new Date(), {
        start: DateBegin,
        end: DateEnd,
      });
    } else {
      return false;
    }
  });

  return orderBy(newEvents, 'DateBegin');
}
